const simpleParallax = require('simple-parallax-js');
const parallaxBanners = document.querySelectorAll('.parallaxBanner');

if (parallaxBanners) {
    new simpleParallax(parallaxBanners, {
        delay: .6,
        transition: 'cubic-bezier(0,0,0,1)',
    });
}